import React, { useEffect, useState } from "react";
import { Button, Form, Image, InputGroup } from "react-bootstrap";
import { default as config } from "../config.json";
import "../SepeteEkle.css"; // Import the external CSS file
import { turkishCurrencyFormatterNoPrecision } from "../utils";
import AskQuestionModal from "./AskQuestionModal";

export default function SepeteEkle(props) {
  const {
    setFeatures,
    setProduct,
    product,
    feature,
    decrementProductItemHandler,
    productQuantity,
    incrementProductItemHandler,
    setFeature,
    setQueryByName,
    setProductQuantity,
    updateCartHandler,
    navigate,
  } = props;

  const [showQuestions, setShowQuestions] = useState(false);
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    if (product.questions) {
      setQuestions(
        product.questions.map((q) => ({
          ...q,
          answers: [...q.answers.map((a) => ({ ...a, selected: false }))],
        }))
      );
    }
  }, [product]);

  const sepeteEkleHandler = async () => {
    await updateCartHandler(productQuantity, questions);
    if (setQueryByName) {
      setQueryByName("");
    }
    if (navigate) {
      navigate(`/category/order?rootCategory=`);
    }
    setFeature("");
    setProduct("");
    setFeatures([]);
    setProductQuantity(1);
  };

  return (
    <div className="sepete-ekle-container">
      <div
        className="product-sepetekle-card"
        onClick={() => setFeatures(product.features)}
      >
        <Image
          className="product-sepetekle-image"
          src={product.image || config.default_image}
          alt={product.name}
          rounded
        />
        <div className="product-sepetekle-info">
          <h5>
            {feature && !feature.name?.startsWith("Normal")
              ? feature.name + " "
              : ""}
            {product.name}
          </h5>
          <span>
            {turkishCurrencyFormatterNoPrecision(
              product.price + (feature ? feature.price : 0)
            )}
          </span>
        </div>
      </div>
      <div className="quantity-container">
        <InputGroup>
          {product.isHalfPortion && (
            <Button
              className="half-portion-btn"
              onClick={() => {
                if (productQuantity > 0.5) {
                  decrementProductItemHandler(0.5);
                }
              }}
            >
              -1/2
            </Button>
          )}
          <Button
            className="quantity-btn"
            onClick={() => {
              if (productQuantity > 1) {
                decrementProductItemHandler();
              }
            }}
          >
            <i className="fas fa-minus-circle"></i>
          </Button>
          <Form.Control
            type="text"
            disabled
            value={`${productQuantity} adet`}
            className="quantity-input"
          />
          <Button
            className="quantity-btn"
            onClick={() => incrementProductItemHandler()}
          >
            <i className="fas fa-plus-circle"></i>
          </Button>
          {product.isHalfPortion && (
            <Button
              className="half-portion-btn"
              onClick={() => incrementProductItemHandler(0.5)}
            >
              +1/2
            </Button>
          )}
        </InputGroup>
      </div>
      <div className="actions-container">
        <Button
          className="add-to-cart-btn"
          onClick={async () => {
            if (product.questions?.length > 0) setShowQuestions(true);
            else await sepeteEkleHandler();
          }}
        >
          <i className="fa fa-shopping-cart"></i> Sepete Ekle
        </Button>
        <Button
          className="cancel-btn"
          onClick={() => {
            setFeature("");
            setProduct("");
            setFeatures([]);
            setProductQuantity(1);
            if (setQueryByName) setQueryByName("");
          }}
        >
          <i className="fas fa-close"></i> Vazgeç
        </Button>
      </div>
      {showQuestions && product.questions?.length > 0 && (
        <AskQuestionModal
          questions={questions}
          setQuestions={setQuestions}
          showQuestions={showQuestions}
          setShowQuestions={setShowQuestions}
          sepeteEkleHandler={sepeteEkleHandler}
        />
      )}
    </div>
  );
}
